import { GetVendorBranch_vendor_getVendorBranchByID_vendorBranch } from '../../graphql/athena/types/GetVendorBranch';
import InfoIcon from '../../icons/InfoIcon';
import { capitalCase } from '../../utils/string';
import HorizontalLayout from '../layouts/HorizontalLayout';
import VerticalLayout from '../layouts/VerticalLayout';
import ComingSoonEditButton from './ComingSoonEditButton';

interface BranchInfoProps {
  branch?: GetVendorBranch_vendor_getVendorBranchByID_vendorBranch;
}

const BranchInfo = ({ branch }: BranchInfoProps) => {
  if (!branch) return null;
  return (
    <VerticalLayout
      style={{ width: 'calc(50% - 24px)', minWidth: 256 }}
      className="flex-auto h-8 pa-5 bg-white ma-4 bo-radius-2"
    >
      <HorizontalLayout className="justify-between items-center">
        <HorizontalLayout className="items-center">
          <InfoIcon />
          <h2 className="pl-4">Basic Info</h2>
        </HorizontalLayout>
        <ComingSoonEditButton />
      </HorizontalLayout>
      <HorizontalLayout>
        <VerticalLayout className="gray4 w-8">
          <div>Branch Name</div>
          <div>Email</div>
          <div>Phone</div>
          <div>Status</div>
        </VerticalLayout>
        <VerticalLayout>
          <div>{branch.name}</div>
          <div>{branch.organization?.email}</div>
          <div>{branch.organization?.primaryPhone}</div>
          <div>{capitalCase(branch.status)}</div>
        </VerticalLayout>
      </HorizontalLayout>
    </VerticalLayout>
  );
};

export default BranchInfo;
